module.exports = __webpack_public_path__ + "img/item1.619a7eca.png";